import React from 'react';
import styled from 'styled-components';
import Container from '../atoms/Container';
import { Link } from 'gatsby';
import GeneralForm from '../organisms/GeneralForm';

const Holder = styled.div`
  background-color: ${props => props.theme.colours.grey};
  padding: 4rem 0;
`;

const Inner = styled.div`
  @media( ${props => props.theme.breakpoints.lg} ) {
    margin: 0 4rem;
  }
`;

const Text = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  a { text-decoration: underline; }
  > :first-child { margin-top: 0; }
  > :last-child { margin-bottom: 0; }
`;

function ContactFormHolder() {
  return (
    <Holder>
      <Container>
        <Inner>
          <Text>
            <p>We welcome your enquiries, and will respond without delay.</p>
            <h2>Function & Events</h2>
            <p>Please place your enquiry <Link to="/enquire">Here</Link></p>
            <h2>General Enquiries:</h2>
          </Text>
          <GeneralForm/>
        </Inner>
      </Container>
    </Holder>
  )
}

export default ContactFormHolder;
